// extracted by mini-css-extract-plugin
export var button = "_fr-4";
export var hasDarkBackground = "_fr-7";
export var hasLightBackground = "_fr-6";
export var iconWrapper = "_fr-0";
export var large = "_fr-2";
export var medium = "_fr-1";
export var small = "_fr-5";
export var xsmall = "_fr-3";